"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRSignatureSSSPlugin = exports.SecurityHeader = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const features_1 = require("../../../../features");
const authoriser_helper_1 = require("../../../../features/authoriser/helpers/authoriser.helper");
var SecurityHeader;
(function (SecurityHeader) {
    SecurityHeader["AUTHORIZATION_REQUIRED"] = "Authorization-Required";
    SecurityHeader["SIGNATURE_KEY_EXPIRED"] = "Signature-Key-Expired";
    SecurityHeader["LIMIT_EXCEEDED"] = "limit-exceeded";
})(SecurityHeader || (exports.SecurityHeader = SecurityHeader = {}));
class XHRSignatureSSSPlugin {
    constructor(signature) {
        this.name = this.constructor.name;
        this.requestId = null;
        this.signature = signature;
    }
    isLastProcessRequest() {
        return this.signature.isProcessConfirmable(this.requestId);
    }
    handleRequest(request) {
        return __awaiter(this, void 0, void 0, function* () {
            this.requestId = (0, authoriser_helper_1.hashRequestURL)(request.url);
            if (this.isLastProcessRequest()) {
                request.headers = Object.assign(Object.assign({}, request.headers), { progressId: this.signature.getSignatureId() });
            }
            return request;
        });
    }
    handleResponse(response) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { httpStatus, responseHeaders: { ['x-security']: securityHeader }, }, } = response;
            // eslint-disable-next-line complexity
            return new Promise(resolve => {
                var _a;
                const initializeSignatureProcess = () => {
                    this.resolveOriginalRequest = resolve;
                    this.originalResponse = response;
                    this.signature.initialize({
                        processId: (0, authoriser_helper_1.hashRequestURL)(response.reference.url),
                        challengeResponse: response.data.data,
                        onCancel: () => {
                            var _a;
                            (_a = this.resolveOriginalRequest) === null || _a === void 0 ? void 0 : _a.call(this, this.originalResponse);
                            this.resolveOriginalRequest = undefined;
                        },
                        onConfirm: () => {
                            response.calls.originCall();
                        },
                        onRetry: () => {
                            response.calls.originCall();
                        },
                        originalRequest: response.calls.originCall,
                        url: response.reference.url,
                    });
                };
                switch (httpStatus) {
                    case web_ui_framework_1.HTTP_STATUS.FORBIDDEN:
                    case web_ui_framework_1.HTTP_STATUS.FORBIDDEN_AUTHORISER:
                        if (securityHeader === SecurityHeader.AUTHORIZATION_REQUIRED) {
                            initializeSignatureProcess();
                        }
                        else if (this.isLastProcessRequest()) {
                            this.signature.setErrorState(features_1.SignatureStateEnum.SIGNATURE_FAILED);
                        }
                        else {
                            resolve(response);
                        }
                        break;
                    case web_ui_framework_1.HTTP_STATUS.PRECONDITION_FAILED:
                        if (securityHeader === SecurityHeader.SIGNATURE_KEY_EXPIRED || securityHeader === SecurityHeader.LIMIT_EXCEEDED) {
                            if (!this.signature.isProcessStarted()) {
                                initializeSignatureProcess();
                            }
                            const errorType = securityHeader === SecurityHeader.SIGNATURE_KEY_EXPIRED
                                ? features_1.SignatureError.EXPIRED_SIGNATURE_KEY
                                : features_1.SignatureError.CONSECUTIVE_ERRORS;
                            this.signature.setErrorState(features_1.SignatureStateEnum.SIGNATURE_FAILED, errorType);
                            return;
                        }
                        resolve(response);
                        break;
                    default:
                        if (this.isLastProcessRequest()) {
                            (_a = this.resolveOriginalRequest) === null || _a === void 0 ? void 0 : _a.call(this, response);
                            this.resolveOriginalRequest = undefined;
                            this.signature.finishSuccessfully();
                        }
                        resolve(response);
                }
            });
        });
    }
}
exports.XHRSignatureSSSPlugin = XHRSignatureSSSPlugin;
//# sourceMappingURL=xhrSignatureSSSPlugin.js.map